module.exports = __webpack_public_path__ + "static/img/title.f3544fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/divinemap/title.png
// module id = +Lbo
// module chunks = 1